import { useState } from "react";
import CustomButton from "../../components/CustomButton";
import { endpoint } from "../../assets/api/endpoint";
import { apiHandler } from "../../assets/api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";



const DeleteYourAccount = () => {
    const [selectedReasons, setSelectedReasons] = useState([]);
    const { accessToken } = useSelector((state) => state.loginInfo);
    const navigate = useNavigate();

 const handleConfirmDelete = async () => {

    if (!selectedReasons || selectedReasons.length === 0) {
        toast.error("Please select at least one reason.");
        return;
    }

    const queryString = selectedReasons
        .map(reason => `reason=${encodeURIComponent(reason)}`)
        .join("&");

    const fullUrl = `${endpoint?.DELETE_ACCOUNT}?${queryString}`;

    try {
        const response = await apiHandler({
            url: fullUrl,
            method: "POST",
            authToken: accessToken?.accessToken,
        });

        if (!response?.data?.error_description) {
            toast.success("Account deleted successfully");
        } else {
            toast.error("Something went wrong");
        }
    } catch (error) {
        console.error("Error deleting account:", error);
        toast.error("Error deleting account");
    }
};



    const handleCheckboxChange = (e) => {
        const value = e.target.value;
        setSelectedReasons((prev) =>
            prev.includes(value)
                ? prev.filter((reason) => reason !== value)
                : [...prev, value]
        );
    };

    const reasons = [
        "Concerned about my data",
        "Created a second account",
        "Can't find people to play",
        "Privacy concerns",
        "Too busy/too distracting",
        "Something else",
    ];
    const onCancel = () => {
        navigate('/profile')
    }


    return (
        <div className="container d-flex justify-content-center p-4">
            <div className="row border p-4 shadow rounded-4" style={{ width: '75%', backgroundColor: '#fdfdfd' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="col-lg-5 d-flex align-items-center gap-3">
                        <h5 className="mb-0" style={{ fontWeight: 600 }}>Delete Your Account</h5>
                    </div>
                </div>

                <div className="card p-4 border-0">
                    <h4 className="mb-3">Deleting your account</h4>
                    <p className="text-muted mb-4">
                        We're sorry to see you leave. Could you let us know why you're deleting your account?
                    </p>

                    <form className="row">
                        {reasons.map((reason, index) => (
                            <div className="form-check mb-3 col-lg-6" key={index}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={reason}
                                    id={`reason-${index}`}
                                    onChange={handleCheckboxChange}
                                    checked={selectedReasons.includes(reason)}
                                />
                                <label className="form-check-label ms-2" htmlFor={`reason-${index}`}>
                                    {reason}
                                </label>
                            </div>
                        ))}
                        <div className=" d-flex justify-content-between align-items-center">
                            <CustomButton
                                buttonText="Continue"
                                className="mt-3"
                                style={{
                                    width: "200px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    background: "#006FFD",
                                    color: "#FFFFFF",
                                    fontWeight: '500',
                                    border: 'none'
                                }}
                                onClick={handleConfirmDelete}
                            />


                            <CustomButton
                                buttonText="Cancel"
                                style={{
                                    width: "200px",
                                    height: "48px",
                                    border: '1px solid #006FFD',
                                    borderRadius: "12px",
                                    color: "#006FFD",
                                    fontWeight: '500',
                                    background: "#fff"
                                }}
                                onClick={onCancel}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DeleteYourAccount;
